import { Component, inject, OnInit } from '@angular/core'
import { PageComponent } from '@client/Components/ui/Page/Page.Component'
import { Table } from '@ui/Table'
import Order from '@client/Order'
import { OrdersService } from '@client/Services/OrdersService'
import Pagination from '@ui/Pagination'
import { createOrder } from '@client/utils'
import HttpError from '@ui/HttpError'
import { CdkTableComponent } from '@ui/Components/Table/CdkTable.Component'
import { PaginatorComponent } from '@ui/Components/Paginator/Paginator.Component'
import { SystemConfigService } from '@client/Services/SystemConfigService'
import { Router } from '@angular/router'

@Component({
	selector: 'orders',
	templateUrl: './Orders.Component.html',
	imports: [PageComponent, CdkTableComponent, PaginatorComponent],
})
export class OrdersComponent extends Table<Order> implements OnInit {
	protected readonly ordersService: OrdersService

	private readonly systemConfigService: SystemConfigService

	private readonly router: Router

	private orders: Order[] = []

	constructor() {
		super()
		this.ordersService = inject(OrdersService)
		this.systemConfigService = inject(SystemConfigService)
		this.router = inject(Router)
	}

	public ngOnInit() {
		this.ordersService.clearLocalStorageKey().resetFilter()

		this.ordersService.filterable = createOrder()

		this.displayColumns = ['id', 'status', 'total', 'amount_paid']

		this.tableEntities = [
			{
				columnDef: 'id',
				header: 'Order ID',
				accessorKey: 'id',
			},
			{
				columnDef: 'status',
				header: 'Status',
				accessorCallback(entity: Order): string {
					return entity.getStatus()
				},
				getRowColor(entity: Order): string {
					return entity.getStatusColour()
				},
			},
			{
				columnDef: 'total',
				header: 'Total',
				accessorKey: 'total',
				type: 'currency',
				currency: (entity: Order) => {
					return {
						currency: entity.currency,
						currencyPrecision: entity.currency_precision,
						locale: this.systemConfigService.config.locale,
					}
				},
			},
			{
				columnDef: 'amount_paid',
				header: 'Amount Paid',
				accessorKey: 'amount_paid',
				type: 'currency',
				currency: (entity: Order) => {
					return {
						currency: entity.currency,
						currencyPrecision: entity.currency_precision,
						locale: this.systemConfigService.config.locale,
					}
				},
			},
		]

		this.fetchOrders()
	}

	protected readonly setPaginator = async (
		paginator: Pagination,
	): Promise<void> => {
		this.ordersService.setPaginator(paginator)

		await this.fetchOrders(false)
	}

	protected gotToOrder = (order: Order): void => {
		this.router.navigateByUrl(`/my-account/orders/${order.id}`)
	}

	private readonly fetchOrders = async (
		resetPaginator: boolean = true,
	): Promise<void> => {
		if (resetPaginator) {
			this.ordersService.paginatorInit(true)
		}

		try {
			this.orders = await this.ordersService.filter()

			this.setTableData(this.orders)
		} catch (error) {
			if (!(error instanceof HttpError)) {
				throw error
			}
		}
	}
}
